import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import {
  SET_COMPANY_UNADDED_REWARDS,
  SET_COMPANY_REWARDS_FAMILIES,
  SET_REWARDS_ERROR,
  SET_REWARDS_FAMILY,
  REWARD_FAMILY_MESSAGE,
  GET_REWARDS_FAMILY,
  CREATE_REWARD_FAMILY,
  ADD_REWARD_TO_FAMILY_SUCCESS,
  UPDATE_REWARD_TO_FAMILY_SUCCESS,
  INIT_REWARDS,
  REFRESH_SILAE_REWARDS_LAST_SYNC_SUCCESS,
  REFRESH_SILAE_REWARDS_STATUS_SUCCESS,
} from '../actions';

const initialState = {
  companyUnaddedRewards: null,
  familyData: null,
  familyMessage: null,
  companyRewardsFamilies: null,
  status: STATUS_NOT_REQUESTED,
  lastSyncTimeRewards: '',
  lastSyncingStatusRewards: false,
};

export const rewardsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_COMPANY_UNADDED_REWARDS:
      return {
        ...state,
        status: STATUS_SUCCESS,
        companyUnaddedRewards: action.payload,
      };

    case SET_COMPANY_REWARDS_FAMILIES:
      return {
        ...state,
        status: STATUS_SUCCESS,
        companyRewardsFamilies: action.payload,
      };

    case SET_REWARDS_ERROR:
      return { ...state, status: STATUS_ERROR };

    case GET_REWARDS_FAMILY:
    case CREATE_REWARD_FAMILY:
      return { ...state, status: STATUS_LOADING };

    case SET_REWARDS_FAMILY:
      return {
        ...state,
        status: STATUS_SUCCESS,
        familyData: action.payload,
      };

    case REWARD_FAMILY_MESSAGE:
      return { ...state, familyMessage: action.payload };

    case ADD_REWARD_TO_FAMILY_SUCCESS:
      return {
        ...state,
        familyData: {
          ...state.familyData,
          companyRewards: [
            action.payload,
            ...(state.familyData?.companyRewards || []),
          ],
        },
      };

    case UPDATE_REWARD_TO_FAMILY_SUCCESS:
      return {
        ...state,
        familyData: {
          ...state.familyData,
          companyRewards: (state.familyData?.companyRewards || []).map(
            (reward) =>
              reward.id === action.payload.id ? action.payload : reward
          ),
        },
      };

    case REFRESH_SILAE_REWARDS_LAST_SYNC_SUCCESS: {
      const { data } = action.payload;
      return { ...state, lastSyncTimeRewards: data };
    }

    case REFRESH_SILAE_REWARDS_STATUS_SUCCESS: {
      const { data } = action.payload;
      return { ...state, lastSyncingStatusRewards: data };
    }

    case INIT_REWARDS:
      return initialState;

    default:
      return state;
  }
};
